// extracted by mini-css-extract-plugin
export default {"layout":"DesktopLayout_layout__gQIm1","mockup":"DesktopLayout_mockup__c1Ul8","image":"DesktopLayout_image__jQ-+s"};